import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";

export interface GetCardBinsRequest {
    id?: number;
    bin?: string | number;
    bankCode?: string;
    cardRangeStart?: string;
    cardRangeEnd?: string;
}

export interface CardBinResponse {
    id: number;
    bankCode: string;
    bankName: string;
    cardRangeStart: string;
    cardRangeEnd: string;
    cardNumberLen: string;
    paymentSystem: string;
    paymentSystemName: string;
    cardType: string;
    cardTypeName: string;
    cardSubType: string;
    cardSubTypeName: string;
    brandCode: string;
    brandName: string;
    urlBankLogo: string;
    urlCardBrandLogo: string;
    urlCardAssociationLogo: string;
}

async function getCardBins(data: GetCardBinsRequest): Promise<any> {
    try {
        return (await axiosInstance.post("/Payment/GetCardBins", data)).data;
    } catch (ex) {
        throw (ex as AxiosError).response?.data || ex;
    }
}

export function useGetCardBins() {
    return useMutation((data: GetCardBinsRequest) => getCardBins(data));
}
